import errorModule from 'src/js/modules/error';
import checkoutServiceClient from 'src/js/modules/checkoutservice-client/service-client';
import statusNames from '../constants/status-names';
import status from '../../status';
import selectors from '../selectors';
import actions from '../actions';
import getUpdatedBillingProfiles from '../helpers/get-updated-billing-profiles';
import resolveHttpClientError from '../../../common/helpers/resolve-http-client-error';

const handleBillingProfilesUpdate = (deletedId, dispatch, state) => {
  const currentProfiles = selectors.getBillingProfiles(state);
  const newProfiles = getUpdatedBillingProfiles(currentProfiles, { toRemove: { id: deletedId } });
  dispatch(actions.setBillingProfiles(newProfiles));
};

const deleteBillingProfile = (id) => async (dispatch, getState) => {
  const state = getState();
  const cosClient = checkoutServiceClient.get();

  dispatch(status.actions.setStatus(statusNames.DELETE_BILLING_PROFILE, status.constants.LOADING));

  try {
    await cosClient.billingProfiles.delete(id);

    dispatch(
      status.actions.setStatus(statusNames.DELETE_BILLING_PROFILE, status.constants.SUCCEEDED)
    );

    const billingProfilesStatus = selectors.getBillingProfilesStatus(state);

    if (billingProfilesStatus === status.constants.SUCCEEDED) {
      handleBillingProfilesUpdate(id, dispatch, state);
    }
  } catch (e) {
    errorModule.operations.catchError(e);
    const error = resolveHttpClientError(e);

    console.error(error);
    dispatch(status.actions.setStatus(statusNames.DELETE_BILLING_PROFILE, status.constants.FAILED));

    throw error;
  }
};

export default deleteBillingProfile;
